"use client";
import BreadCrumb from "@/app/components/lib/breadcrumb/BreadCrumb";
import { useIsMobile } from "@/hooks/useIsMobile";
import React from "react";

const ContactUsBreadCrumb: React.FC<{ title: string }> = ({ title }) => {
  const mobile = useIsMobile();
  if (mobile) return;
  return <BreadCrumb hierarchy={[{ text: title }]} />;
};

export default ContactUsBreadCrumb;
